export const environment = {
	production: false,
	isMockEnabled: false,
	authTokenKey: "authce9d77b308c149d5992a80073637e4d5",
	openIDToken:"",
	webservice: "/webservice/",
	tokencsrf: "",
	tokenauth: "",
	tokenAtyl: "",
	timeRefreshNotifs: 50,
	limitdossiers: 50,
	limitConsultations: 50,
    limitTotalFileSize: 25, //en Mo,
    limitFileSize: 5
}
